'use es6';

import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getGoToDashboardLink = goToDashboard => {
  if (!goToDashboard) {
    return null;
  }
  return /*#__PURE__*/_jsx(Link, {
    onClick: goToDashboard,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reportActions.goToLink.goToDashboard`
    })
  });
};
const showActionAlert = (type, {
  message,
  options = {},
  goToDashboard,
  displayRedirectLink = true
}) => {
  if (displayRedirectLink) {
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "100",
          as: "span",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message,
            options: options
          })
        }), getGoToDashboardLink(goToDashboard)]
      }),
      type,
      'data-test-id': 'report-save-success-alert'
    });
  } else {
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message,
        options: options
      }),
      type
    });
  }
};
export const showSuccessNotification = (params = {}) => {
  showActionAlert('success', params);
};
export const showFailureNotification = (params = {}) => {
  showActionAlert('danger', params);
};
export const showMoveFailureNotification = () => {
  showFailureNotification({
    message: 'reportActions.move.failure'
  });
};
export const showAddSuccessNotification = (reportName, dashboardName, goToDashboard, displayRedirectLink = true) => {
  showSuccessNotification({
    message: 'reportActions.add.success.single',
    options: {
      reportName,
      dashboardName
    },
    goToDashboard,
    displayRedirectLink
  });
};
export const showBulkAddSuccessNotification = (dashboardName, goToDashboard, displayRedirectLink = true) => {
  showSuccessNotification({
    message: 'reportActions.add.success.multi',
    options: {
      dashboardName
    },
    goToDashboard,
    displayRedirectLink
  });
};
export const showAddFailureNotification = () => {
  showFailureNotification({
    message: 'reportActions.add.failure'
  });
};